<script>
	import { user, view, send_images } from "../client.svelte.js";
	import {calc_defaultCS} from "../core.js";
  import {getContext} from "svelte";
	import Input from "../elements/Input.svelte";
	import Select from "../elements/Select.svelte";
	import PortraitDialog from "../dialogs/PortraitDialog.svelte";

	let { character, mode ='create' }  = $props()   // mode ∈ {'create', 'edit', 'newchar'}
	let actions = getContext('dialog-actions')

	let extended = $state(false), showExtended = $state(false)
	let portrait = $state()   // either the tokenURL or an objectURL of the new portrait
	let defaults = $derived({callsign: character.CS ?? calc_defaultCS(character.name, character.isIndividuum), templID: character.ID,
													name: character.name, level: character.level, affiliation: character.affiliation, individuum: character.isIndividuum})
	let changes = $state({callsign: null, name: null, individuum: character.isIndividuum, level: null, affiliation: null, tknfile: null})

	let portraitPicker

	/// reset all character specific data if new character is chosen
	$effect(() => {
		actions.create = actions.edit = actions.delete = actions.newChar = null
		if (character) {
			portrait = character.tokenURL
			extended = false
			showExtended = false
			changes = {callsign: null, name: null, individuum: character.isIndividuum, level: null, affiliation: null, tknfile: null}
			if (!character.ZUB) {
				actions.create = {templID: character.ID, callsign: defaults.callsign}
			}
		}
	})

	// $inspect(`VARIANT - defaults`, defaults)

	const affilOptions = [{value: 'enemy', name: "Feind"}, {value: 'friend', name: "Freund"}, {value: 'neutral', name: "Neutral"}]

	const filter_changes = (data => Object.fromEntries(Object.entries(data).filter(([key,val]) => val && val !== defaults[key])))

	/** receives the cropped portrait from the Portrait dialog; it is sent with the variant later **/
	function load_portrait(file) {
		if (portrait?.startsWith('blob:'))  URL.revokeObjectURL(portrait)
		portrait = URL.createObjectURL(file)
		changes.tknfile = file
		check_actions()
	}

	function change_name() {
		if (mode !== 'edit')
			changes.callsign = calc_defaultCS(changes.name, changes.individuum)
		check_callsign()
	}

	function change_individuum(e) {
		changes.callsign = (changes.individuum) ? changes.callsign.toUpperCase() : changes.callsign.toLowerCase()
	}

	function check_callsign(e) {
		const csInput = document.getElementById('callsign')
		if (!csInput)  return
		if (changes.callsign && changes.callsign in (view.adventure?.particips ?? {})) {
			csInput.setCustomValidity(`Callsign cannot be ${changes.callsign} since it is already used in this adventure!`)
			csInput.reportValidity()
		} else {
			csInput.setCustomValidity("")
			if (mode === 'edit')  actions.edit = changes
		}
		check_actions()
	}

	function check_actions(e) {
		const anychange = Object.values(changes).some(Boolean)
		if (mode === 'create') {
			const complete = anychange && Boolean(changes.name && changes.callsign && document.getElementById('callsign')?.validity.valid !== false)
			if (extended) {
				actions.newChar = anychange && Object.assign(defaults, filter_changes(changes))
				actions.create = null
			} else {
				actions.create = anychange && Object.assign(defaults, filter_changes(changes))
				actions.newChar = null
			}
		} else if (mode === 'edit') {
			actions.create = null
			actions.edit = Object.assign({variID: character.ID}, filter_changes(changes))
		} else if (mode === 'newchar') {
			actions.create = Object.assign({templID: character.ID}, filter_changes(changes))
		}
		showExtended = (mode === 'create' && Object.values(changes).some(Boolean))
	}


</script>


<!------------------------------- HTML ------------------------------------->

	<div class="dlg-body" data-help="variant">
		<form class=container autocomplete=off onchange={check_actions}>
			<figure class="spanRows" title={character.descript} onclick={() => portraitPicker.pick()}>
				<div class="affiliation {defaults.affiliation}"></div>
				<img src={portrait} alt={character.ID} title={character.ID} />
			</figure>

			<div class=datagrid>
				<Input field=name bind:value={changes.name} defaultval={defaults.name} separate class=quadspan onchange={change_name} />
				{#if mode !== 'newchar'}
					<Input field=callsign bind:value={changes.callsign} defaultval={defaults.callsign} separate disabled={mode === 'edit'} style="text-align: center"
								 onchange={check_callsign} />
				{:else}
					<span/>
					<span/>
				{/if}
				<p></p>
				<label for=uniqueCheck>Individuum?</label>
				<input type=checkbox id=uniqueCheck bind:checked={changes.individuum} defaultChecked={defaults.individuum} onchange={change_individuum}>
				<Input field=level bind:value={changes.level} defaultval={defaults.level} type=number separate />
				<p></p>
				<Select field=affiliation bind:value={changes.affiliation} options={affilOptions} defaultval={defaults.affiliation} separate />
				{#if showExtended}
					<hr class="separator">
					<input type=checkbox id=extendedCheck class=extendedCheck bind:checked={extended} onchange={check_actions}>
					<label for=extendedCheck class=quadspan>Weitere Anpassungen machen?</label>
				{/if}
			</div>
		</form>
	</div>

	<PortraitDialog bind:this={portraitPicker} id='variant-portrait-dialog' onselect={load_portrait}/>


<!------------------------------- STYLE ------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	// frame, header, body and footer come from .dlg* in static/pentelion.sass

	.container
		display: flex

	.container img
		width: 200px
		padding: 8px
		object-fit: contain
		border-radius: 100%

	.container img.enemy
		background-color: darkred
	.container img.friend
		background-color: darkgreen

	.datagrid
		display: grid
		grid-template-columns: 6ch 4ch 2ch 12ch 10ch
		column-gap: 4px
		grid-row-gap: 8px
		align-content: start
		width: 340px
		padding: 16px
		background-color: #111111

		.separator
			grid-column: 1 / -1
			margin: 1em 0
			width: 100%
			border-color: colors.$grey-20

	.buttonBar
		width: 336px
		margin: 32px 4px 4px 4px
		display: flex
		gap: 36px
		justify-content: center

	h3
		color: colors.$white
		grid-column: span 2
		justify-self: center

	label
		line-height: 175%

	input[type=checkbox]
		color: lightgrey
		accent-color: dimgrey

	input[type="checkbox"]:not(:checked)
		appearance: none
		margin: 4px 34px
		width: 20px
		height: 20px
		background: dimgrey

	input[type=checkbox].extendedCheck
		appearance: none
		margin: 4px
		width: 20px
		height: 20px
		background: colors.$grey-20
		display: inline-flex
		align-items: center
		justify-content: center
		cursor: pointer
		font-family: 'Font Awesome 6 Free'
		font-weight: 900
		font-size: 25px

		&:checked::before
			content: "\f00c"
			color: green

	.bar
		grid-column: span 5
		margin: 3em 1em

		.warning
			color: yellow

		.error
			color: red

</style>